import { SxProps, TableCell, TableCellProps } from '@mui/material';

import { colors } from 'src/global/styles/colors';

interface CustomTableCellProps extends TableCellProps {
  sx?: SxProps;
}
export const CustomTableHeadCell = (props: CustomTableCellProps) => {
  const { sx, children, ...rest } = props;
  return (
    <TableCell
      sx={{
        color: colors.neutral90,
        borderBottom: 'none',
        ...sx,
      }}
      align='left'
      {...rest}>
      {children}
    </TableCell>
  );
};

export const CustomTableBodyCell = (props: CustomTableCellProps) => {
  const { sx, children, ...rest } = props;
  return (
    <TableCell
      sx={{
        borderBottom: 'none',
        color: 'white',
        paddingY: '8px',
        verticalAlign: 'baseline',
        ...sx,
      }}
      align='left'
      {...rest}>
      {children}
    </TableCell>
  );
};
